import React, { useState ,useEffect} from 'react';
import AOS from "aos";
import "aos/dist/aos.css";

import {
  Film,
  Clapperboard,
  UserCircle,
  Briefcase,
  FileText,
  Tv,
  Music2,
  Mic,
  Users,
  Sword,
  Volume2,
  Headphones,
  Radio,
  Disc,
  Zap,
  Wrench,
  Camera,
  Image,
  Scissors,
  Palette,
  Hammer,
  Lightbulb,

  Settings,
  UserPlus,
  ChevronDown,
  ChevronUp
} from "lucide-react";

import {
  HardHat,
  Boxes,
  Paintbrush,
  Shirt
} from "lucide-react";

function FilmDepartmentsShowcase() {

    const [visibleCount, setVisibleCount] = useState(4);

 useEffect(() => {
    AOS.init({
      duration: 900,
      easing: "ease-out-cubic",
      once: true,
      offset: 100,
    });
  }, []);

const CARD_ANIMATIONS = [
  "fade-up",
  "fade-right",
  "fade-left",
  "zoom-in",
];


    const allDepartments = [
        {
            title: 'Directors, Artists & Editors',
            badge: 'Creative Leadership',
            badgeGradient: 'from-purple-500 to-indigo-500',
            data: [
                { id: 1, name: 'FILM DIRECTOR', icon: <Film className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-purple-500 to-indigo-500', description: 'Leading creative vision' },
                { id: 2, name: 'ASSISTANT FILM DIRECTOR', icon: <Clapperboard className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-blue-500 to-cyan-500', description: 'Supporting directorial work' },
                { id: 3, name: 'ART DIRECTOR', icon: <Briefcase className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-pink-500 to-rose-500', description: 'Visual design leadership' },
                { id: 4, name: 'ASSISTANT ART DIRECTOR', icon: <UserCircle className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-orange-500 to-red-500', description: 'Art department support' },
                { id: 5, name: 'CASTING DIRECTOR', icon: <Users className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-emerald-500 to-teal-500', description: 'Talent selection expert' },
                { id: 6, name: 'ASSISTANT CASTING DIRECTOR', icon: <Users className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-green-500 to-emerald-500', description: 'Casting support specialist' },
                { id: 7, name: 'PRODUCER', icon: <Briefcase className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-violet-500 to-purple-500', description: 'Production oversight' },
                { id: 8, name: 'ASSISTANT PRODUCER', icon: <Briefcase className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-indigo-500 to-blue-500', description: 'Production coordination' },
                { id: 9, name: 'SCREENPLAY', icon: <FileText className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-amber-500 to-orange-500', description: 'Story development' },
                { id: 10, name: 'ASSISTANT SCREENPLAY', icon: <FileText className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-yellow-500 to-amber-500', description: 'Writing support' },
                { id: 11, name: 'FEATURE FILM & SERIAL', icon: <Tv className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-cyan-500 to-blue-500', description: 'Long-form production' },
                { id: 12, name: 'CHOREOGRAPHER', icon: <Music2 className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-fuchsia-500 to-pink-500', description: 'Dance & movement design' },
                { id: 13, name: 'ASSISTANT FEATURE FILM & SERIAL', icon: <Tv className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-sky-500 to-cyan-500', description: 'Production assistance' },
                { id: 14, name: 'FILM WRITER', icon: <FileText className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-rose-500 to-pink-500', description: 'Script creation' },
                { id: 15, name: 'WRITER', icon: <FileText className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-red-500 to-orange-500', description: 'Content writing' },
                { id: 16, name: 'JUNIOR WRITER', icon: <FileText className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-lime-500 to-green-500', description: 'Apprentice writer' },
                { id: 17, name: 'NOVICE', icon: <FileText className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-teal-500 to-emerald-500', description: 'Entry-level writer' },
                { id: 18, name: 'MUSIC DIRECTOR', icon: <Music2 className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-purple-500 to-violet-500', description: 'Musical leadership' },
                { id: 19, name: 'MUSIC COMPOSER', icon: <Music2 className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-indigo-500 to-purple-500', description: 'Original composition' },
                { id: 20, name: 'ARRANGER', icon: <Disc className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-blue-500 to-indigo-500', description: 'Music arrangement' },
                { id: 21, name: 'MUSICIAN', icon: <Music2 className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-pink-500 to-fuchsia-500', description: 'Performance artist' },
                { id: 22, name: 'SINGER', icon: <Mic className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-orange-500 to-amber-500', description: 'Vocal performance' },
                { id: 23, name: 'DUBBING & VOICE ARTIST', icon: <Mic className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-emerald-500 to-green-500', description: 'Voice recording' },
                { id: 24, name: 'INSTRUMENT PLAYER', icon: <Music2 className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-cyan-500 to-teal-500', description: 'Musical instruments' },
            ]
        },
        {
            title: 'Production Department',
            badge: 'Production Team',
            badgeGradient: 'from-blue-500 to-cyan-500',
            data: [
                { id: 1, name: 'PRODUCTION MANAGER', icon: <Briefcase className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-blue-500 to-indigo-500', description: 'Production oversight' },
                { id: 2, name: 'ASSISTANT PRODUCTION MANAGER', icon: <UserPlus className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-cyan-500 to-blue-500', description: 'Production support' },
                { id: 3, name: 'PRODUCTION CONTROLLER', icon: <Settings className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-purple-500 to-violet-500', description: 'Production control' },
                { id: 4, name: 'ASSISTANT PRODUCTION CONTROLLER', icon: <Settings className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-indigo-500 to-purple-500', description: 'Control assistance' },
                { id: 5, name: 'CAMERA MAN', icon: <Camera className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-orange-500 to-red-500', description: 'Camera operations' },
                { id: 6, name: 'ASSISTANT CAMERA MAN', icon: <Camera className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-amber-500 to-orange-500', description: 'Camera support' },
                { id: 7, name: 'PHOTOGRAPHER', icon: <Image className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-pink-500 to-rose-500', description: 'Photography specialist' },
                { id: 8, name: 'ASSISTANT PHOTOGRAPHER', icon: <Image className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-fuchsia-500 to-pink-500', description: 'Photography support' },
                { id: 9, name: 'HAIR DRESSER', icon: <Scissors className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-emerald-500 to-teal-500', description: 'Hair styling expert' },
                { id: 10, name: 'ASSISTANT HAIR DRESSER', icon: <Scissors className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-green-500 to-emerald-500', description: 'Hair styling support' },
                { id: 11, name: 'HAIR STYLIST', icon: <Scissors className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-teal-500 to-cyan-500', description: 'Style specialist' },
                { id: 12, name: 'MAKEUP MAN', icon: <Palette className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-violet-500 to-purple-500', description: 'Makeup artistry' },
                { id: 13, name: 'ASSISTANT MAKEUP MAN', icon: <Palette className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-purple-500 to-fuchsia-500', description: 'Makeup support' },
                { id: 14, name: 'DRESS MAN', icon: <Shirt className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-red-500 to-pink-500', description: 'Wardrobe management' },
                { id: 15, name: 'COSTUME', icon: <Shirt className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-orange-500 to-amber-500', description: 'Costume design' },
                { id: 16, name: 'ASSISTANT DRESS MAN', icon: <Shirt className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-yellow-500 to-orange-500', description: 'Wardrobe assistance' },
                { id: 17, name: 'PRODUCTION BOY', icon: <Users className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-lime-500 to-green-500', description: 'Production support' },
                { id: 18, name: 'CAMERA TECHNICIAN', icon: <Camera className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-sky-500 to-blue-500', description: 'Camera maintenance' },
                { id: 19, name: 'ASSISTANT CAMERA TECHNICIAN', icon: <Camera className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-cyan-500 to-sky-500', description: 'Technical support' },
                { id: 20, name: 'CAMERA ATTENDANT', icon: <Camera className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-blue-500 to-cyan-500', description: 'Camera care' },
                { id: 21, name: 'STILL PHOTOGRAPHER', icon: <Image className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-rose-500 to-red-500', description: 'Still photography' },
                { id: 22, name: 'D.O.P', icon: <Camera className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-indigo-500 to-blue-500', description: 'Director of photography' },
                { id: 23, name: 'ASSISTANT D.O.P', icon: <Camera className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-purple-500 to-indigo-500', description: 'DOP support' },
                { id: 24, name: 'CANO PIECE', icon: <Camera className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-violet-500 to-purple-500', description: 'Camera equipment' },
            ]
        },
        {
            title: 'Fight & Sound Department',
            badge: 'Action & Audio',
            badgeGradient: 'from-red-500 to-orange-500',
            data: [
                { id: 1, name: 'FIGHT MASTER', icon: <Sword className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-red-500 to-orange-500', description: 'Action choreography expert' },
                { id: 2, name: 'SPECIAL FIGHTER', icon: <Sword className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-orange-500 to-amber-500', description: 'Specialized stunts' },
                { id: 3, name: 'FIGHTER', icon: <Sword className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-amber-500 to-yellow-500', description: 'Stunt performance' },
                { id: 4, name: 'DUPLICATE', icon: <Users className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-yellow-500 to-lime-500', description: 'Body double specialist' },
                { id: 5, name: 'SOUND RECORDIST', icon: <Volume2 className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-blue-500 to-cyan-500', description: 'Audio recording expert' },
                { id: 6, name: 'ASSISTANT SOUND RECORDIST', icon: <Headphones className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-cyan-500 to-teal-500', description: 'Sound recording support' },
                { id: 7, name: 'CORDLESS MIC OPERATOR', icon: <Mic className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-purple-500 to-violet-500', description: 'Wireless mic handling' },
                { id: 8, name: 'WALKIE TALKIE', icon: <Radio className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-indigo-500 to-blue-500', description: 'Communication operator' },
                { id: 9, name: 'DJ SOUND SYSTEM', icon: <Disc className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-pink-500 to-rose-500', description: 'Audio system specialist' },
                { id: 10, name: 'ASSISTANT DJ SOUND SYSTEM', icon: <Disc className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-fuchsia-500 to-pink-500', description: 'Sound system support' },
                { id: 11, name: 'GUN & SPECIAL EFFECT MASTER', icon: <Zap className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-emerald-500 to-teal-500', description: 'Effects coordination' },
                { id: 12, name: 'ASSISTANT GUN & SPECIAL EFFECT', icon: <Zap className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-green-500 to-emerald-500', description: 'Effects assistance' },
                { id: 13, name: 'WORKER GUN & SPECIAL EFFECT', icon: <Wrench className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-lime-500 to-green-500', description: 'Effects technician' },
            ]
        },
        {
            title: 'Setting Department',
            badge: 'Technical Crew',
            badgeGradient: 'from-slate-500 to-gray-500',
            data: [
                { id: 1, name: 'HEAD MISTRY', icon: <HardHat className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-slate-500 to-gray-500', description: 'Construction supervisor' },
                { id: 2, name: 'CIVIL MISTRY', icon: <Hammer className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-gray-500 to-zinc-500', description: 'Civil construction' },
                { id: 3, name: 'CARPENTER', icon: <Hammer  className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-amber-600 to-orange-600', description: 'Woodwork specialist' },
                { id: 4, name: 'ASSISTANT CARPENTER', icon: <Hammer  className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-yellow-600 to-amber-600', description: 'Carpentry support' },
                { id: 5, name: 'MOLDER', icon: <Boxes className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-stone-500 to-gray-600', description: 'Molding expert' },
                { id: 6, name: 'ASSISTANT MOLDER', icon: <Boxes className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-gray-600 to-slate-600', description: 'Molding assistance' },
                { id: 7, name: 'EXTRA', icon: <Users className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-blue-500 to-indigo-500', description: 'Additional support' },
                { id: 8, name: 'SPOT BOY', icon: <UserPlus className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-cyan-500 to-blue-500', description: 'Set assistance' },
                { id: 9, name: 'P. RUSTOM', icon: <Users className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-teal-500 to-cyan-500', description: 'Production support' },
                { id: 10, name: 'TAILOR', icon: <Scissors className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-purple-500 to-violet-500', description: 'Garment specialist' },
                { id: 11, name: 'TAPESS', icon: <Shirt className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-fuchsia-500 to-purple-500', description: 'Fabric work' },
                { id: 12, name: 'PAINTER', icon: <Paintbrush className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-pink-500 to-rose-500', description: 'Painting specialist' },
                { id: 13, name: 'FABRICATOR', icon: <Wrench className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-orange-600 to-red-600', description: 'Metal fabrication' },
                { id: 14, name: 'WELDER', icon: <Zap className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-red-600 to-rose-600', description: 'Welding expert' },
                { id: 15, name: 'HELPER', icon: <Users className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-emerald-500 to-green-500', description: 'General assistance' },
                { id: 16, name: 'ELECTRICIAN', icon: <Zap className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-yellow-500 to-amber-500', description: 'Electrical work' },
                { id: 17, name: 'LIGHT MAN', icon: <Lightbulb className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-amber-500 to-orange-500', description: 'Lighting specialist' },
                { id: 18, name: 'CO-ORDINATOR', icon: <Settings className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-indigo-500 to-purple-500', description: 'Team coordination' },
                { id: 19, name: 'TYPIST', icon: <FileText className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-blue-600 to-indigo-600', description: 'Documentation' },
                { id: 20, name: 'ASSISTANT TYPIST', icon: <FileText className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-sky-600 to-blue-600', description: 'Typing support' },
                { id: 21, name: 'CRANE MAN', icon: <Settings className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-slate-600 to-gray-700', description: 'Crane operations' },
                { id: 22, name: 'CRANE OPERATOR', icon: <Settings className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-gray-700 to-zinc-700', description: 'Crane specialist' },
                { id: 23, name: 'TROLLY ATTENDANT', icon: <Camera className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-violet-500 to-purple-500', description: 'Trolly management' },
                { id: 24, name: 'TROLLY PANTHER', icon: <Camera className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-purple-500 to-fuchsia-500', description: 'Camera movement' },
                { id: 25, name: 'JIMMY JIB', icon: <Camera className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-rose-500 to-pink-500', description: 'Jib operations' },
                { id: 26, name: 'DOLLY PANTHER', icon: <Camera className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-pink-500 to-rose-500', description: 'Dolly operator' },
                { id: 27, name: 'GAFFER', icon: <Lightbulb className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-yellow-400 to-orange-400', description: 'Chief lighting tech' },
                { id: 28, name: 'BOOM MAN', icon: <Mic className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-cyan-500 to-blue-500', description: 'Boom microphone' },
                { id: 29, name: 'LIGHT MAN', icon: <Lightbulb className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-lime-500 to-green-500', description: 'Lighting technician' },
                { id: 30, name: 'SPOT BOY INCHARGE', icon: <UserCircle className="w-6 h-6 md:w-8 md:h-8" />, gradient: 'from-emerald-600 to-teal-600', description: 'Spot boy supervisor' },
            ]
        }
    ];

      const displayedDepartments = allDepartments.map(section => ({
        ...section,
        data: section.data.slice(0, visibleCount)
    }));

    const handleLoadMore = () => {
        setVisibleCount(prev => prev + 6);
    };

const PROFESSIONAL_GRADIENTS = [
  "from-blue-800 to-blue-600",
  "from-indigo-800 to-indigo-600",
  "from-slate-700 to-slate-500",
  "from-teal-700 to-teal-500",
  "from-amber-600 to-amber-500",
  "from-emerald-700 to-emerald-500",
];


  return (
    <div className="bg-gradient-to-b from-sky-50 via-white to-sky-100">
      <div className="relative py-12 md:py-16 lg:py-20">
        <div className="container max-w-7xl mx-auto px-2 md:px-4">

          {/* ================= HEADER ================= */}
          <div className="text-center mb-14" data-aos="fade-down">
            <span className="inline-block px-4 py-2 bg-gradient-to-r from-blue-800 to-blue-600 text-white text-sm font-semibold rounded-full shadow">
              All Departments
            </span>

            <h2
              className="text-3xl md:text-5xl font-bold text-slate-800 mt-4"
              data-aos="zoom-in"
              data-aos-delay="150"
            >
              Complete Professional Departments
            </h2>

            <p
              className="text-slate-600 mt-2 max-w-2xl mx-auto"
              data-aos="fade-up"
              data-aos-delay="250"
            >
              Explore all specialized departments in our film production association
            </p>
          </div>

          {/* ================= SECTIONS ================= */}
          {displayedDepartments.map((section, sectionIndex) => (
            <div key={sectionIndex} className="mb-16">

              {/* Section title */}
              <div
                className="text-center mb-10"
                data-aos={sectionIndex % 2 === 0 ? "fade-right" : "fade-left"}
              >
                <span
                  className={`inline-block px-4 py-2 bg-gradient-to-r ${section.badgeGradient} text-white text-sm font-semibold rounded-full shadow`}
                >
                  {section.badge}
                </span>

                <h3 className="text-2xl md:text-4xl font-bold text-slate-800 mt-3">
                  {section.title}
                </h3>
              </div>

              {/* Cards */}
              <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                {section.data.map((dept, index) => {
                  const gradient =
                    PROFESSIONAL_GRADIENTS[dept.id % PROFESSIONAL_GRADIENTS.length];

                  const animation =
                    CARD_ANIMATIONS[index % CARD_ANIMATIONS.length];

                  return (
                    <div
                      key={dept.id}
                      data-aos={animation}
                      data-aos-delay={index * 80}
                      data-aos-duration="700"
                      className="group relative bg-white rounded-xl p-4 shadow-sm hover:shadow-lg transition-all duration-300 hover:-translate-y-1 border border-slate-100 overflow-hidden"
                    >
                      {/* Hover bg */}
                      <div
                        className={`absolute inset-0 bg-gradient-to-br ${gradient} opacity-0 group-hover:opacity-[0.06] transition`}
                      />

                      {/* Icon */}
                      <div
                        className={`relative w-12 h-12 rounded-lg bg-gradient-to-br ${gradient} flex items-center justify-center text-white mb-3 shadow`}
                      >
                        {dept.icon}
                      </div>

                      {/* Text */}
                      <h4 className="text-sm md:text-base font-semibold text-slate-800 mb-1">
                        {dept.name}
                      </h4>
                      <p className="text-xs text-slate-600 leading-snug">
                        {dept.description}
                      </p>
                    </div>
                  );
                })}
              </div>
            </div>
          ))}

          {/* ================= LOAD MORE ================= */}
          {visibleCount < Math.max(...allDepartments.map(d => d.data.length)) && (
            <div className="text-center mt-12" data-aos="zoom-in-up">
              <button
                onClick={handleLoadMore}
                className="inline-flex items-center gap-2 px-8 py-3 bg-gradient-to-r from-blue-800 to-blue-600 text-white font-semibold rounded-full shadow-lg hover:shadow-xl transition"
              >
                Load More Departments
                <ChevronDown className="w-5 h-5" />
              </button>
            </div>
          )}

        </div>
      </div>
    </div>
  );
}

export default FilmDepartmentsShowcase;